var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"info-modal","size":"xl","cancel-title":"Anuluj","centered":"","ok-title":"Zamknij","ok-only":"","title":"Komunikat"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }